module.exports = __webpack_public_path__ + "static/media/background-2-480w.74a41a7d.jpg";